export default __webpack_public_path__ + "static/media/icons8-instagram-logo.897c12ac.svg";